import { ArrowRight } from "@mui/icons-material";
import { Box, IconButton, styled } from "@mui/material";
import { MIN_CELL_WIDTH } from "../../utils/layout";
export const Logo = styled("img")(({ theme }) => ({
  maxHeight: 80,
  maxWidth: 300,
  borderBottom: `2px solid ${theme.palette.secondary.main}`,
  marginTop: 15,
}));

export const VideoCanvas = styled("video-player-container")(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundColor: "transparent",
  position: "absolute",
}));

export const AvatarList = styled("ul")(({ theme }) => ({
  position: "absolute",
  width: "100%",
  height: "100%",
  pointerEvents: "none",
  top: 0,
  left: 0,
  padding: 0,
  margin: 0,
}));

export const videoContainer = {
  display: "flex",
  position: "relative",
  justifyContent: "center",
  width: "100%",
  height: "100%",
  zIndex: 7,
};

export const videoContainerIsSharing = {
  // este width debe ser el mismo que
  // MIN_CELL_WIDTH de layout.js
  width: `${MIN_CELL_WIDTH}px`,
  flexShrink: 0,
};

export const viewportMobileReceiveSharing = {
  display: "grid",
  gridTemplateRows: "1fr 1fr",
  gridTemplateColumns: "1fr",
  position: "relative",
  width: "100%",
  height: "100%",
  overflow: "hidden",
  boxSizing: "border-box",
  // gap: 1vw, para que haya espacio entre
  // el selfview y el preview
  gap: "1vw",
  backgroundColor: "rgb(0, 0, 0)",
  justifyContent: "center",
  padding: 5,
};

export const viewport = {
  position: "relative",
  display: "flex",
  height: "100%",
  width: "100%",
  overflow: "hidden",
  boxSizing: "border-box",
  // gap: 1vw, para que haya espacio entre
  // el selfview y el preview
};

export const ChatContainer = styled("div")(({ theme, isChatOpen }) => ({
  width: isChatOpen ? "350px" : "0",
  height: "50%",
  overflow: "hidden",
  transition: "width 0.8s ease",
  position: "fixed",
  bottom: 0,
  right: 0,
  backgroundColor: "#1e1e1e",
  display: "flex",
  flexDirection: "column",
  boxShadow: isChatOpen ? "-5px 0 10px rgba(0,0,0,0.2)" : "none",
  zIndex: 9997,
}));

export const ChatToggleButton = styled(IconButton)(({ theme }) => ({
  padding: "10px",
  color: "white",
  border: "none",
  cursor: "pointer",
  "&.Mui-disabled": {
    color: "white",          // keep white color
    opacity: 0.5,            // optional: make it look visually disabled
    cursor: "not-allowed",   // show disabled cursor
  },
}));

export const ChatIcon = styled(ArrowRight)({
  color: "black",
});

export const StyledChatToggleButtonContainer = styled('div')(({ theme }) => ({
  position: "fixed",
  right: 20,
  zIndex: 9998,
  padding: "10px",
  color: "white",
  border: "none",
  [theme.breakpoints.down("md")]: {
    position: "relative",
    margin: "auto",
  },
}));

export const ZoomContainer = styled(Box)(({ theme, height, deberiaEstarEnSalaEspera }) => ({
  ...(deberiaEstarEnSalaEspera ? {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: "10px 30px",
    height: "100%",
    // eslint-disable-next-line max-len
    background: `radial-gradient(circle, ${theme.palette.primary.homeGradient1}, ${theme.palette.primary.homeGradient2})`,
    width: "100%",
    overflow: "hidden",
    borderBottom: `1px solid ${theme.palette.primary.grey}`,
    "& a": {
      textDecoration: "none",
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "center",
      padding: "20px",
    },
  } : {
    height: height,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // eslint-disable-next-line max-len
    background: `linear-gradient(to right, ${theme.palette.primary.homeGradient1}, ${theme.palette.primary.homeGradient2})`,
    overflow: "hidden",
    borderBottom: `1px solid ${theme.palette.primary.grey}`,
    "& a": {
      textDecoration: "none",
    },

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
  })

}));

export const ZoomViewsContainer = styled(Box, {
  shouldForwardProp: (prop) =>
    !["isRecieveSharing", "esLayoutMobile", "deberiaEstarEnSalaEspera"].includes(prop),
})(({
  theme,
  isRecieveSharing,
  esLayoutMobile,
  deberiaEstarEnSalaEspera
}) => ({
  ...(esLayoutMobile && isRecieveSharing
    ? viewportMobileReceiveSharing
    : {
      ...viewport,
      backgroundColor: deberiaEstarEnSalaEspera ? "transparent" : "rgb(0, 0, 0)",

      [theme.breakpoints.down("sm")]: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: 5,
      },
    }),
}));